import fetch from '../core/fetch';
import { parseResponse } from '../core/fetch/response';
import AuthorizationHeader from './authorization-header';

export default class Pricing {
  static async getProductRates(country, subscriptionType = 'multi-month') {
    const headers = await AuthorizationHeader.getCognitoHeader();
    const url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/public/subscription-types/${process.env.REACT_APP_CLIENT_PLAY_PRODUCT_SKU}?type=${subscriptionType}&country=${country}`;
    const params = {
      method: 'GET',
      ...headers,
    };
    const response = await fetch(url, params);
    return parseResponse(response);
  }
}
